import * as plotUtil from '../plot_util'

export default function (coordinates) {
    if (coordinates.length < 3) return coordinates;
    return plotUtil.getCurvePoints(0.3, coordinates);
}